import React, { useState } from 'react';

const CustomerHistoryModal = ({ isOpen, onClose, customer, onSaveHistory }) => {
  const [content, setContent] = useState('');
  const [type, setType] = useState('정비상담'); // 정비상담, 일반메모, 불만(VOC) 등 분류

  // 🚀 [추가] 수정 모드 제어용 상태
  const [editingId, setEditingId] = useState(null);
  const [editType, setEditType] = useState('정비상담');
  const [editContent, setEditContent] = useState('');

  if (!isOpen || !customer) return null;

  // 신규 히스토리 추가
  const handleAddHistory = () => {
    if (!content.trim()) {
      alert('기록할 내용을 입력해주세요.');
      return;
    }

    // 날짜 포맷 (예: 2026. 05. 27. 14:30)
    const now = new Date();
    const dateStr = `${now.getFullYear()}. ${String(now.getMonth() + 1).padStart(2, '0')}. ${String(now.getDate()).padStart(2, '0')}. ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

    const newHistory = {
      id: Date.now().toString(),
      date: dateStr,
      type: type,
      content: content
    };

    // 기존 히스토리 배열에 새 항목 추가 (최신순 정렬을 위해 앞에 추가)
    const updatedHistories = [newHistory, ...(customer.histories || [])];
    
    // 부모 컴포넌트(Customer.js)로 저장 요청 전달
    onSaveHistory(updatedHistories);
    setContent(''); // 입력창 초기화
  };

  // 🚀 [추가] 히스토리 삭제 로직
  const handleDelete = (historyId) => {
    if (!window.confirm('이 히스토리 기록을 정말 삭제하시겠습니까?')) return;
    
    // 삭제할 ID를 제외한 나머지 배열만 남김
    const updatedHistories = (customer.histories || []).filter(h => h.id !== historyId);
    onSaveHistory(updatedHistories);
  };

  // 🚀 [추가] 히스토리 수정 시작 로직
  const handleEditStart = (h) => {
    setEditingId(h.id);
    setEditType(h.type);
    setEditContent(h.content);
  };

  // 🚀 [추가] 히스토리 수정 저장 로직
  const handleEditSave = (historyId) => {
    if (!editContent.trim()) {
      alert('내용을 입력해주세요.');
      return;
    }

    // 기존 배열을 순회하며 수정된 ID의 내용만 업데이트
    const updatedHistories = (customer.histories || []).map(h => {
      if (h.id === historyId) {
        return { ...h, type: editType, content: editContent }; // 날짜는 기존 날짜 유지
      }
      return h;
    });

    onSaveHistory(updatedHistories);
    setEditingId(null); // 수정 모드 종료
  };

  const getBadgeColor = (hType) => {
    if (hType === '정비상담') return { bg: '#eff6ff', text: '#2563eb', border: '#bfdbfe' };
    if (hType === '불만(VOC)') return { bg: '#fef2f2', text: '#dc2626', border: '#fecaca' };
    return { bg: '#f8fafc', text: '#475569', border: '#e2e8f0' }; // 일반메모
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {/* 반투명 배경 (클릭 시 닫힘) */}
      <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(15, 23, 42, 0.6)' }} onClick={onClose} />
      
      {/* 모달 본체 */}
      <div style={{ position: 'relative', background: 'white', width: '600px', maxHeight: '85vh', borderRadius: '16px', display: 'flex', flexDirection: 'column', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }}>
        
        {/* 헤더 */}
        <div style={{ padding: '20px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc', borderRadius: '16px 16px 0 0' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '800', color: '#1e293b' }}>
              📝 {customer.name} 고객 히스토리 관리
            </h2>
            <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
              {customer.carNumber || '차량번호 없음'} | {customer.phone}
            </div>
          </div>
          <button onClick={onClose} style={{ padding: '8px 16px', background: '#e2e8f0', color: '#475569', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>닫기 ✖</button>
        </div>

        {/* 히스토리 목록 영역 (스크롤) */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px', background: '#f1f5f9', display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {customer.histories && customer.histories.length > 0 ? (
            customer.histories.map((h) => {
              const colors = getBadgeColor(h.type);
              return (
                <div key={h.id} style={{ background: 'white', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                  
                  {/* 🔴 [수정 모드 UI] */}
                  {editingId === h.id ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <select 
                          style={{ width: '120px', padding: '6px', border: '1px solid #e2e8f0', borderRadius: '6px', outline: 'none', fontSize: '12px', fontWeight: 'bold', color: '#475569' }}
                          value={editType}
                          onChange={(e) => setEditType(e.target.value)}
                        >
                          <option value="정비상담">정비상담</option>
                          <option value="일반메모">일반메모</option>
                          <option value="불만(VOC)">불만(VOC)</option>
                        </select>
                        <span style={{ fontSize: '11px', color: '#94a3b8' }}>{h.date}</span>
                      </div>
                      <textarea 
                        style={{ width: '100%', boxSizing: 'border-box', padding: '10px', border: '1px solid #3b82f6', borderRadius: '6px', outline: 'none', fontSize: '13px', resize: 'none', height: '60px' }}
                        value={editContent}
                        onChange={(e) => setEditContent(e.target.value)}
                      />
                      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
                        <button 
                          onClick={() => setEditingId(null)}
                          style={{ padding: '6px 12px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' }}
                        >
                          취소
                        </button>
                        <button 
                          onClick={() => handleEditSave(h.id)}
                          style={{ padding: '6px 12px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' }}
                        >
                          저장
                        </button>
                      </div>
                    </div>
                  ) : (
                    
                  /* 🔵 [일반 모드 UI] */
                    <>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', fontWeight: 'bold', background: colors.bg, color: colors.text, border: `1px solid ${colors.border}`, padding: '2px 8px', borderRadius: '4px' }}>
                          {h.type}
                        </span>
                        
                        {/* 우측 영역: 날짜 및 수정/삭제 버튼 */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                          <span style={{ fontSize: '11px', color: '#94a3b8' }}>{h.date}</span>
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button 
                              onClick={() => handleEditStart(h)}
                              style={{ background: 'none', border: 'none', padding: 0, fontSize: '11px', color: '#64748b', cursor: 'pointer', textDecoration: 'underline' }}
                            >
                              수정
                            </button>
                            <button 
                              onClick={() => handleDelete(h.id)}
                              style={{ background: 'none', border: 'none', padding: 0, fontSize: '11px', color: '#ef4444', cursor: 'pointer', textDecoration: 'underline' }}
                            >
                              삭제
                            </button>
                          </div>
                        </div>
                      </div>
                      <div style={{ fontSize: '13px', color: '#1e293b', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
                        {h.content}
                      </div>
                    </>
                  )}
                </div>
              );
            })
          ) : (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#94a3b8', fontSize: '13px' }}>
              아직 기록된 히스토리가 없습니다. 첫 상담 내용을 기록해 보세요.
            </div>
          )}
        </div>

        {/* 신규 히스토리 입력 영역 */}
        <div style={{ padding: '20px', borderTop: '1px solid #e2e8f0', background: 'white', borderRadius: '0 0 16px 16px' }}>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <select 
              style={{ width: '120px', padding: '10px', border: '1px solid #e2e8f0', borderRadius: '8px', outline: 'none', fontSize: '13px', fontWeight: 'bold', color: '#475569' }}
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="정비상담">정비상담</option>
              <option value="일반메모">일반메모</option>
              <option value="불만(VOC)">불만(VOC)</option>
            </select>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <textarea 
              style={{ flex: 1, padding: '12px', border: '1px solid #e2e8f0', borderRadius: '8px', outline: 'none', fontSize: '13px', resize: 'none', height: '60px' }}
              placeholder="고객과의 상담 내용이나 정비 특이사항을 기록하세요."
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
            <button 
              onClick={handleAddHistory}
              style={{ width: '80px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}
            >
              기록 추가
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerHistoryModal;